const doc = [({"en":({"js":({"admin":({"team_surveys":({"show":({"user_step":({"points":"Points", "time":"Time"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;